import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { JobTypeListResult } from '../models/job-type.model';

@Injectable({ providedIn: 'root' })
export class JobTypeService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/jobtypes`;

  getJobTypes(): Observable<JobTypeListResult> {
    return this.http.get<JobTypeListResult>(this.baseUrl);
  }
}
